export default __webpack_public_path__ + "static/media/carousel-3.6e161497.jpg";